<div class="flex flex-row flex-nowrap min-w-fit items-center pr-4 gap-2">
  @if (icon()) {
    <soft-icon [name]="icon()" class="mr-2 scale-150"></soft-icon>
  }
  <div class="flex flex-col w-full">
    <span class="text-sm font-semibold">{{ title() }}</span>
    <span [class.soft-link]="!readonly()" class="soft-link text-sm" (click)="!readonly() && click.emit()">{{ value() }}</span>
  </div>
</div>
